import React from 'react';
import { App } from '../../../models/app';
import { List, ListItem, Paper } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import { detectLocale } from '../../../utils/transformationHelper';
import { sanitizeText } from '../../../utils/helpers';

interface ComponentProps {
  app: App;
}

export const detectBenefit = (
  localeBenefit: Readonly<{ elements: readonly string[] }> | undefined,
  defaultBenefit: Readonly<{ elements: readonly string[] }> | undefined,
) => {
  if (localeBenefit) {
    return localeBenefit;
  } else {
    return defaultBenefit;
  }
};

export const AppBenefits: React.FC<ComponentProps> = ({ app }): JSX.Element => {
  const { t } = useTranslation();
  const { benefits } = app;
  const localeBenefit = detectLocale(app)?.benefits;

  const displayBenefit = detectBenefit(localeBenefit, benefits);

  return (
    <>
      {!!benefits?.elements?.length ? (
        <Paper square>
          <h3 data-testid='benefitHeader'>{t('app_details.benefits')}</h3>
          <List className={styles.benefitsList}>
            {displayBenefit?.elements?.map((benefit, index) => {
              let sanitizedBenefit = sanitizeText(benefit);
              return (
                <ListItem key={index}>
                  <p>{sanitizedBenefit}</p>
                </ListItem>
              )
            })}
          </List>
        </Paper>
      ) : false}
    </>
  );
};
